import "./DeleteSectionModal.scss";

import { FC, useState } from "react";

import { SectionType } from "components/server-types";
import { t } from "i18n/i18n";
import { showConfirmationModal } from "mds/components/Modal";
import { TextField } from "mds/components/TextField";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useAppSelector } from "store";
import { selectCourseCodeBySectionId } from "store/selectors/section";

export const showUnlinkConfirmationModal = ({
  section,
  templateTitle,
}: {
  section: SectionType;
  templateTitle: string;
}) => {
  const unlinkSectionTitle = t("sidebar_options_menu.unlink_confirm_button");

  return showConfirmationModal({
    title: unlinkSectionTitle,
    hideCancelConfirmButtons: true,
    labelText: t("sidebar_options_menu.unlink_confirm_label", { name: section.title }),
    children: (onClose, onConfirm) => (
      <UnlinkSectionModal
        sectionId={section.id}
        templateTitle={templateTitle}
        unlinkSectionTitle={unlinkSectionTitle}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    ),
  });
};

type UnlinkSectionModalProps = {
  unlinkSectionTitle: string;
  sectionId: string;
  templateTitle: string;
  onConfirm: (data?: boolean) => void;
  onClose: () => void;
};

// eslint-disable-next-line react-refresh/only-export-components
const UnlinkSectionModal: FC<UnlinkSectionModalProps> = ({
  sectionId,
  unlinkSectionTitle,
  templateTitle,
  onConfirm,
  onClose,
}) => {
  const [disableUnlink, setDisableUnlink] = useState<boolean>(true);

  const courseTitle = useAppSelector((state) => selectCourseCodeBySectionId(state, sectionId));
  const handleCourseConfirmationCheck = (text: string) => {
    setDisableUnlink(text !== courseTitle);
  };

  return (
    <div className="section-delete-modal mt-8 flex flex-col items-start gap-8">
      <div className="section-delete-warning">
        {t("sidebar_options_menu.unlink_confirm_description", { template: templateTitle })}
      </div>

      <div className="flex flex-col gap-2">
        <label htmlFor="course-code">{t("section_list_panel.course_confirm_label")}</label>

        <TextField
          id="course-code"
          placeholder={t("section_list_panel.course_placeholder")}
          isEditing
          onChange={(event) => handleCourseConfirmationCheck(event.target.value)}
        />
      </div>

      <div className="flex w-full justify-end gap-2">
        <SquareButton kind="tertiary" size="m" title={t("common.cancel")} onClick={onClose}>
          {t("common.cancel")}
        </SquareButton>

        <SquareButton
          disabled={disableUnlink}
          kind="caution"
          size="m"
          title={unlinkSectionTitle}
          onClick={() => onConfirm(true)}
        >
          {unlinkSectionTitle}
        </SquareButton>
      </div>
    </div>
  );
};
